/**
 * Piqpath wordmark + tagline.
 *
 * - Wordmark uses Sora 700 (logo-only). Body copy stays in Inter.
 * - Sizes: sm = 18px (header), md = 28px (auth pages), lg = 40px (splash / static hero).
 * - Tagline default: visible for `md` + `lg`, hidden for `sm`.
 */
const SIZES = {
    sm: { word: 18, tagline: 11, gap: 0 },
    md: { word: 28, tagline: 13, gap: 4 },
    lg: { word: 40, tagline: 14, gap: 6 },
};

export default function Logo({
    size = "sm",
    showTagline,
    align = "left",
    className = "",
    "data-testid": testId = "piqpath-logo",
}) {
    const s = SIZES[size] || SIZES.sm;
    const tagline = showTagline ?? (size !== "sm");
    const alignCls =
        align === "center"
            ? "items-center text-center"
            : "items-start text-left";

    return (
        <span
            className={`inline-flex flex-col leading-none ${alignCls} ${className}`}
            data-testid={testId}
            data-logo="piqpath"
        >
            <span
                style={{
                    fontFamily: '"Sora", "Inter", sans-serif',
                    fontWeight: 700,
                    letterSpacing: "-0.02em",
                    color: "#0A0A0A",
                    fontSize: `${s.word}px`,
                    lineHeight: 1,
                }}
                data-testid="piqpath-wordmark"
                data-logo-wordmark="piqpath"
            >
                Piqpath
            </span>
            {tagline && (
                <span
                    style={{
                        fontFamily: "Inter, sans-serif",
                        color: "#6B7280",
                        fontSize: `${s.tagline}px`,
                        letterSpacing: "0.04em",
                        marginTop: `${s.gap}px`,
                        lineHeight: 1.1,
                    }}
                    data-testid="piqpath-tagline"
                >
                    Your trip. Your way.
                </span>
            )}
        </span>
    );
}
